export default __webpack_public_path__ + "img/mask-ipad.9647d60b.png";